import { render, staticRenderFns } from "./ReadMessage.vue?vue&type=template&id=6f0c8175&scoped=true&"
import script from "./ReadMessage.vue?vue&type=script&lang=js&"
export * from "./ReadMessage.vue?vue&type=script&lang=js&"
import style0 from "./ReadMessage.vue?vue&type=style&index=0&id=6f0c8175&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0c8175",
  null
  
)

export default component.exports